import { render, staticRenderFns } from "./VipTipDialog.vue?vue&type=template&id=e5076028&scoped=true"
import script from "./VipTipDialog.vue?vue&type=script&lang=js"
export * from "./VipTipDialog.vue?vue&type=script&lang=js"
import style0 from "./VipTipDialog.vue?vue&type=style&index=0&id=e5076028&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5076028",
  null
  
)

export default component.exports